import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { VerticalSpaceTarget } from 'app/spaces/planograms-editor/store/planogram.store.state';
import {
  ShelfVerticalSpaceDialogMode,
  SpcShelfVerticalSpaceReassignData,
  SpcShelfVerticalSpaceReassignDialog,
} from './spc_shelf_vertical_space_reassign.dialog';

export const openShelfVerticalSpaceReassignDialog = (
  dialog: MatDialog,
  mode: ShelfVerticalSpaceDialogMode,
  hasUpperNeighbor: boolean,
  hasLowerNeighbor: boolean
): Promise<VerticalSpaceTarget | null> => {
  const data: SpcShelfVerticalSpaceReassignData = {
    mode,
    hasUpperNeighbor,
    hasLowerNeighbor,
  };

  return dialog
    .open(SpcShelfVerticalSpaceReassignDialog, {
      width: '560px',
      data,
    })
    .afterClosed()
    .pipe(first())
    .toPromise();
};
